import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lm-saved-search',
  templateUrl: './lm-saved-search.component.html',
  styleUrls: [ './lm-saved-search.component.scss' ]
})
export class LMSavedSearchComponent implements OnInit {

  constructor() { }

  @Input() name: string;
  @Input() description: string;
  @Input() default: boolean;

  ngOnInit(): void {
  }

}
